import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { ChevronDownIcon } from "@gemini/icons";
import { ActionMenu, Checkbox, TextButton } from "@gemini/ui";
import { Controller } from "react-hook-form";
export const SaveSearchOptIn = ({ control, testId, isSaveSearchOptInEnabled, }) => {
    const { t } = useI18n();
    const { brandName } = brandConfiguration;
    if (!isSaveSearchOptInEnabled)
        return;
    return (_jsxs(Box, { children: [_jsx(Controller, { name: "newsletterOptout", control: control, defaultValue: false, render: ({ field: { value, onChange, name, ref } }) => (_jsx(Checkbox, { isOptional: true, "aria-label": "a", hasNecessityIndicator: false, testId: `${testId}.SavedSearchOptIn`, isSelected: value !== null && value !== void 0 ? value : false, ref: ref, onChange: onChange, name: name, defaultSelected: false, children: t("contact.form.saved_search_opt_in.text", {
                        replace: {
                            value: brandName,
                        },
                    }) })) }), _jsx(Controller, { name: "newsletterOptInPreference", control: control, defaultValue: "email-sms", render: ({ field: { value, onChange } }) => (_jsx(ActionMenu, { alignment: "start", menuItems: [
                        {
                            children: "Email / SMS",
                            id: "email-sms",
                            elementType: "button",
                            onAction: () => onChange("email-sms"),
                        },
                        {
                            children: "Email",
                            id: "email",
                            elementType: "button",
                            onAction: () => onChange("email"),
                        },
                        {
                            children: "SMS",
                            id: "sms",
                            elementType: "button",
                            onAction: () => onChange("sms"),
                        },
                    ], onOpenChange: () => { }, children: (props) => (_jsx(TextButton, { ...props, marginHorizontal: "spacing.32", marginTop: "-spacing.32", icon: () => (_jsx(ChevronDownIcon, { "aria-label": "Ship Filled Icon", color: "inherit", size: "sizing.24", marginHorizontal: "spacing.8" })), iconPosition: "end", size: "16", children: t(value
                            ? `contact.form.marketing_opt_in_out_${value}_dropdown_option`
                            : "contact.form.marketing_opt_in_out_email-sms_dropdown_option") })) })) })] }));
};
